import { render, staticRenderFns } from "./Pintaudi.vue?vue&type=template&id=f60dd3fc&scoped=true"
import script from "./Pintaudi.vue?vue&type=script&lang=js"
export * from "./Pintaudi.vue?vue&type=script&lang=js"
import style0 from "./Pintaudi.vue?vue&type=style&index=0&id=f60dd3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60dd3fc",
  null
  
)

export default component.exports